<div class="form">
  <div class="form__logo"><img src="assets/icons/logo.svg" alt="logo" /></div>
  <ng-content></ng-content>
</div>